// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__1DJuj","input":"checkbox_input__3wD2Y","preloaderImg":"checkbox_preloaderImg__2UKB-"};